// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"e37ef120","419":"e7a89ae6","563":"3456baca","787":"59a76d8d","942":"5ba147bb"}[chunkId] + ".chunk.js";
};